import { Component,
         AfterViewInit }        from '@angular/core';
import { MatDialogRef }          from '@angular/material';
import { TrainCycleService }       from './../shared/train-cycle.service';
import { Globals }              from './../common/globals';
import { TrainCycleSortDialogModel } from './train-cycle-sort-dialog.model';
import { TrainCycleDialogModel } from '../train-cycle-dialog/train-cycle-dialog.model';

@Component({
  selector: 'sa-train-cycle-sort-dialog',
  template: require('./train-cycle-sort-dialog.component.html'),
  styles: [require('./train-cycle-sort-dialog.component.scss')]
})
export class TrainCycleSortDialogComponent implements AfterViewInit {

  public model: TrainCycleSortDialogModel;
  public errors = [];
  public parentModel: TrainCycleDialogModel;
  public dataReady = false;

  constructor(
    public dialogRef: MatDialogRef<TrainCycleSortDialogComponent>,
    private trainCyclesService: TrainCycleService,
    public globals: Globals
  ) {
    this.model = new TrainCycleSortDialogModel();
  }

  ngAfterViewInit() {

    this.model.cycleUID = this.parentModel.cycleUID;
    this.trainCyclesService.cycleTrainOrder(this.model.cycleUID).subscribe(res => {
      this.model.cycleName = this.parentModel.name;
      this.model.trains = res;
      this.dataReady = true;
    });
  }

  save() {
    this.errors = [];
    if (this.errors.length === 0) {
      this.trainCyclesService.updateOrder(this.model.cycleUID, this.model.trains).subscribe(res => {
        this.dialogRef.close('save');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-cycle-sort-dialog/train-cycle-sort-dialog.component.ts